import { PieceEvent } from '@apiContract';

export type FilterList = { [key: string]: any };

export interface ISortableTableColumn {
  id: string;
  label: string;
  order: number;
  enabled: boolean;
  sortable?: boolean;
}

// crop and bounding box
export type Coordinates = {
  x: number;
  y: number;
};

export type CropPointId = 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight';

export type CropPointsCoordinates = {
  [key in CropPointId]: Coordinates;
};

export const points: CropPointId[] = ['topLeft', 'topRight', 'bottomLeft', 'bottomRight'];

export enum Roles {
  KTAdmin = 'KTAdmin',
  Admin = 'Admin',
  Mailroom = 'Mailroom',
  Recipient = 'Recipient',
}

export enum MailPieceInboxType {
  Mailroom,
  Recipient,
}

export interface IParsedEvents extends PieceEvent {
  children?: PieceEvent[];
}

export enum ReviewItemsFilterType {
  REQUIRE_VALIDATION = "require validation",
  UNASSIGNED = "unassigned",
  MISSING_TRACKING_NUMBER = "missing tracking",
  DUPLICATE = "duplicate tracking",
  ALL = "with issues",
};